import { useState, useEffect, useContext } from "react";
import { AppContext } from "../../../../desktop/AppProviderDesktop";
import { fetchGetAufa } from "../../../../../faetures/fetch";
import CloseSave from "../../../../design/close";
import ConinerProject from "./ConinerProject";
import "./projectSelectContiner.css";



function ProjectSelectContiner({setClose, flight, onClick}) {
    const [data, setData] = useState({});
    const [dataForServer, setDataForServer] = useState([]);

    const {aufaData} = useContext(AppContext);

    useEffect(() => {
        const dataToUpdate = {};

        Object.keys(aufaData).map((keyAufaData) => {
            dataToUpdate[keyAufaData] = {name: aufaData[keyAufaData]['name'], flights: {A: 0, R: 0, B: 0}, cars: {A: 0, R: 0}};

            for (const type2 of ["flights", "cars"]) {
                aufaData[keyAufaData][type2].map((flight) => {
                    let k = flight[0];
    
                    if (k in dataToUpdate[keyAufaData][type2]) {
                        dataToUpdate[keyAufaData][type2][k] += 1;
                    }
                })
            }
        })

        setData(dataToUpdate);
    }, [])

    function search_project (e) {
        let filter2 = dataForServer.filter((project) => {
            let pattern = new RegExp(e);
            return pattern.test(project.name);
        });
        setData(filter2);
    }

    return (
        <div className={"aufaProjectsContiner"}>
            <div className='aufaProjects-head'>
                <p> בחר פרוייקט </p>
                {setClose && 
                <CloseSave setClose={setClose} bc='none' c='black' hc='rgb(100,100,100)' hbc='none' bold={'bold'}/>
                }
            </div>

            <div className='aufaProject-search'>
                <label>
                    <p> חפש </p>
                    <input type='text' onChange={(e) => search_project(e.target.value)}></input>
                </label>
            </div>

            <div>
                {
                    Object.keys(data).map((keyData, key) => (
                        <ConinerProject 
                        key={key} 
                        data={data[keyData]}
                        onClick2={onClick}
                        flight={flight}
                        />
                    ))
                }
            </div>
        </div>
    )
}


export default ProjectSelectContiner;